module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-plan"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Kontoplan\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "15px"
    },
    attrs: {
      "align": "right"
    },
    on: {
      "click": function($event) {
        _vm.showEmptyAccounts = !_vm.showEmptyAccounts
      }
    }
  }, [(!_vm.showEmptyAccounts) ? _c('span', [_vm._v("Vis konti uden bevægelse")]) : _c('span', [_vm._v("Skjul konti uden bevægelse")])]), _vm._v(" "), (!_vm.loading && _vm.accounts && _vm.accountCategories) ? _c('div', {
    staticClass: "accounts"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.filteredAccounts), function(account) {
    return _c('div', {
      key: account.uuid,
      staticClass: "account"
    }, [_c('div', {
      staticClass: "number"
    }, [_vm._v("\n                " + _vm._s(account.account_number) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("\n                " + _vm._s(account.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(account.entries_total)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "category"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (account.category.uuid),
        expression: "account.category.uuid"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(account.category, "uuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateAccount(account, $event)
        }]
      }
    }, _vm._l((_vm.accountCategories), function(accountCategory) {
      return _c('option', {
        key: accountCategory.uuid,
        domProps: {
          "value": accountCategory.uuid
        }
      }, [_vm._v("\n                        " + _vm._s(accountCategory.name) + "\n                    ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "show"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (account.show),
        expression: "account.show"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(account.show) ? _vm._i(account.show, null) > -1 : (account.show)
      },
      on: {
        "change": [function($event) {
          var $$a = account.show,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(account, "show", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(account, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(account, "show", $$c)
          }
        }, function($event) {
          return _vm.toggleAccount(account)
        }]
      }
    }), _vm._v("\n                 \n                "), (account.show) ? _c('span', [_vm._v("\n                    Synlig\n                ")]) : _c('span', [_vm._v("\n                    Skjult\n                ")])])])
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account bold"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Bogført i perioden")]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._v("Hovedkonto")]), _vm._v(" "), _c('div', {
    staticClass: "show"
  }, [_vm._v("Vis/skjul")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed1d8338"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/accountPlan.vue
// module id = 941
// module chunks = 0